import React,{useContext,useState,useEffect} from 'react'
import {auth} from './firebase'
const AuthContext=React.createContext();
export function useAuth(){
    return useContext(AuthContext);
}
export default function AuthProvider({children}) {
     const [currentUser,setCurrentUser]=useState();
     function signup(email,password){
        return auth.createUserWithEmailAndPassword(email,password)
    }
    function login(email,password){
        return auth.signInWithEmailAndPassword(email,password);
    }
    function forgot(email){
        return auth.sendPasswordResetEmail(email)
    }
    function signout(){
        return auth.signOut();
    }
    useEffect(()=>{
        const unsubscribe= auth.onAuthStateChanged(user =>{
            setCurrentUser(user);
        })
        return unsubscribe;
    },[])
    const value={
        currentUser,
        signup,
        login,
        forgot,
        signout
    }
    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )
}
